import { render, staticRenderFns } from "./GetConfig.vue?vue&type=template&id=c5368800&scoped=true"
import script from "./GetConfig.vue?vue&type=script&lang=ts"
export * from "./GetConfig.vue?vue&type=script&lang=ts"
import style0 from "./GetConfig.vue?vue&type=style&index=0&id=c5368800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5368800",
  null
  
)

export default component.exports